import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { FlexLayoutProps } from '@swyftx/aviary/atoms/Layout/Flex/FlexLayout.styles';
import { Body, Numeric } from '@swyftx/aviary/atoms/Typography';
import { BodyProps } from '@swyftx/aviary/atoms/Typography/Body/Body.styles';

import { formatCurrency } from '@shared/utils';

import { observer } from 'mobx-react-lite';
import { useMarginAccount } from 'src/lib/margin/hooks/account';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

type Props = {
  positionId?: string;
  dynamicColors?: boolean;
  weight?: BodyProps['weight'];
  justifyContent?: FlexLayoutProps['justifyContent'];
  size?: BodyProps['size'];
};

const MarginUsedMargin: React.FC<Props> = observer(
  ({ positionId, justifyContent, size = 'small', weight = 'bold' }) => {
    const { currency } = useMarginAccount();
    const { usedMargin } = useMarginPositionDetails({ positionId });

    if (!positionId || usedMargin === undefined)
      return (
        <FlexLayout spacing={4} justifyContent={justifyContent}>
          <Body weight={weight} size={size} color='primary'>
            -
          </Body>
        </FlexLayout>
      );

    return (
      <FlexLayout spacing={4} justifyContent={justifyContent}>
        <Numeric weight={weight} size={size}>
          {formatCurrency(usedMargin, currency)}
        </Numeric>
        {currency && (
          <Numeric weight={weight} color='secondary' size={size}>
            {currency.code}
          </Numeric>
        )}
      </FlexLayout>
    );
  },
);

export { MarginUsedMargin };
